




































































































































































































































































































































































































































import {
  computed,
  defineComponent,
  nextTick,
  ref,
  toRefs,
  watch,
  vue3Model,
  useRoute,
  PropType,
  onMounted
} from '~/utils/nuxt3-migration'
import CSlider from '~/components/shared/configurable/slider/CSlider.vue'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import { formatNumber } from '~/utils/number'
import { useDeps } from '~/compositions/dependency-container'
import LoanService from '~/services/loan/LoanService'
import LoanCalculatorTimeButton from '~/components/car/classifieds/view/partials/loans/calculator/LoanCalculatorTimeButton.vue'
import { v4 as uuidv4 } from 'uuid'
import LoanPerks from '~/components/car/classifieds/view/partials/loans/perks/LoanPerks.vue'
import CAccordion from '~/components/shared/configurable/accordion/CAccordion.vue'
import LoanCalculatorOpener from '~/components/car/classifieds/view/partials/loans/calculator/LoanCalculatorOpener.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { defineComponentTranslations } from '~/utils/i18n'
import { useI18n } from '~/compositions/i18n'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import CInfoModal from '~/components/shared/configurable/info/CInfoModal.vue'
import ColorsExplanation from '~/components/shared/account/overview/colors/ColorsExplanation.vue'
import { debounce } from '~/utils/function'
import { DEBOUNCE_SWIFT } from '~/constants/debounce'
import {
  LoanInfoExtras,
  LoanMerchantName,
  PiraeusLoanInterestType
} from '~/models/loan'
import { useRequestError } from '~/compositions/request-error'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import { OnlineLoanType } from '~/constants/loan/loans'
import {
  PIRAEUS_CONSUMER_CONTRIBUTION,
  PIRAEUS_CONSUMER_INTEREST,
  PIRAEUS_CONSUMER_MAX_LOAN_AMOUNT,
  PIRAEUS_CONSUMER_MIN_LOAN_AMOUNT,
  PIRAEUS_MORTGAGE_FIXED_RATE_YEARS,
  PIRAEUS_MORTGAGE_MAX_LOAN_AMOUNT,
  PIRAEUS_MORTGAGE_MIN_LOAN_AMOUNT,
  PIRAEUS_MORTGAGE_CONTRIBUTION
} from '~/constants/loan/piraeus'
import PiraeusConsumerLoanTerms from '~/components/car/classifieds/view/partials/loans/calculator/piraeus/PiraeusConsumerLoanTerms.vue'
import CRadioButtonGroup from '~/components/shared/configurable/button/CRadioButtonGroup.vue'
import SantanderLoanDetailsModal from '~/components/car/classifieds/view/partials/loans/calculator/santander/SantanderLoanDetailsModal.vue'
import PiraeusMixedLoanDetailsModal from '~/components/car/classifieds/view/partials/loans/calculator/piraeus/PiraeusMixedLoanDetailsModal.vue'
import PiraeusLoanFormModal from '~/components/car/classifieds/view/partials/loans/calculator/piraeus/PiraeusLoanFormModal.vue'

export default defineComponent({
  model: vue3Model,
  props: {
    modelValue: { type: Boolean, default: false },
    sessionId: {
      type: String,
      default: () => uuidv4()
    },
    simple: {
      type: Boolean,
      required: false,
      default: false
    },
    collapsible: {
      type: Boolean,
      required: false,
      default: false
    },
    inLanding: {
      type: Boolean,
      required: false,
      default: false
    },
    loanType: {
      type: String as PropType<OnlineLoanType>,
      required: false,
      default: 'piraeus-consumer-loan'
    }
  },
  components: {
    PiraeusLoanFormModal,
    PiraeusMixedLoanDetailsModal,
    SantanderLoanDetailsModal,
    CRadioButtonGroup,
    PiraeusConsumerLoanTerms,
    CConfirmationModal,
    ColorsExplanation,
    CInfoModal,
    CPrice,
    CImg,
    LoanCalculatorOpener,
    LoanPerks,
    LoanCalculatorTimeButton,
    CSlider,
    CAccordion
  },
  setup(props, { emit }) {
    const { modelValue, inLanding } = toRefs(props)
    const { state } = useNamespacedStore<ClassifiedViewState>(
      CLASSIFIED_VIEW_NS
    )
    const [loanService] = useDeps(LoanService)
    const { t, tc } = useI18n()
    const handleRequestError = useRequestError()
    const internalExpanded = ref(modelValue.value)
    const showPiraeusTermsModal = ref(false)

    const showDetailsModal = ref(false)
    const infoModalRef = ref(null)
    const isLoanFormVisible = ref(false)

    const isMortgage = computed(
      () => props.loanType === 'piraeus-mortgage-loan'
    )

    const minInstallments = ref(isMortgage.value ? 10 : 6)
    const maxInstallments = ref(isMortgage.value ? 30 : 84)

    const route = useRoute()

    onMounted(() => {
      if (!props.collapsible) {
        loadLoanInfo(true)
      }
    })

    watch(modelValue, (newVal: boolean) => {
      if (loanInstallment.value === null) {
        loadLoanInfo(true)
      }
      internalExpanded.value = newVal
    })

    const classifiedRawPrice = computed(
      () => state.classified?.price.extra.raw_price || 0
    )
    const inClassifiedView = computed(() => {
      return route.value.name?.startsWith('__classifieds_view')
    })

    const hasRangeError = computed(() => {
      return Boolean(
        Number(selectedTimeInput.value) > maxInstallments.value ||
          Number(selectedTimeInput.value) < minInstallments.value
      )
    })

    const minLoanAmount = computed<number>(() =>
      isMortgage.value
        ? PIRAEUS_MORTGAGE_MIN_LOAN_AMOUNT
        : PIRAEUS_CONSUMER_MIN_LOAN_AMOUNT
    )
    const maxLoanAmount = computed<number>(() =>
      isMortgage.value
        ? PIRAEUS_MORTGAGE_MAX_LOAN_AMOUNT
        : PIRAEUS_CONSUMER_MAX_LOAN_AMOUNT
    )

    const initLoanAmount = computed(() => {
      if (!inLanding.value) {
        if (classifiedRawPrice.value > maxLoanAmount.value) {
          return maxLoanAmount.value
        } else if (classifiedRawPrice.value < minLoanAmount.value) {
          return minLoanAmount.value
        }
        return classifiedRawPrice.value
      }
      return maxLoanAmount.value
    })

    const loanAmount = ref(initLoanAmount.value)
    const selectedInterestType = ref<PiraeusLoanInterestType>('fixed')
    const selectedFixedRateYears = ref(PIRAEUS_MORTGAGE_FIXED_RATE_YEARS[0])
    const selectedTimeSlider = ref(maxInstallments.value)
    const selectedTimeInput = ref(maxInstallments.value)
    watch(maxInstallments, (val, oldVal) => {
      if (selectedTimeSlider.value > val) {
        selectedTimeSlider.value = val
      }

      if (selectedTimeInput.value > oldVal && selectedTimeInput.value <= val) {
        // input value had error but now its within max limit so update it to be the same as slider value
        selectedTimeInput.value = selectedTimeSlider.value
      }
    })

    const interestToUse = ref(
      isMortgage.value ? 4.29 : PIRAEUS_CONSUMER_INTEREST
    ) // if mortgage set it somewhere close to what the back will return

    const loanInstallment = ref(null)
    const loanInfoExtras = ref<LoanInfoExtras | null>(null)
    const loadingLoanInfo = ref(false)
    const loadingLoanTarget = ref(false)

    const amountInputRef = ref(null)
    const installmentsInputRef = ref(null)
    const showAmountInput = ref(false)
    const showInstallmentsInput = ref(false)

    function handleTimeButtonClick(time: number) {
      if (selectedTimeSlider.value !== time) {
        selectedTimeSlider.value = time
        loadLoanInfo(false)
      }
    }

    const sliderTooltipFormatter = (v: number) => `${formatNumber(v)} €`
    const durationSliderTooltipFormatter = (v: number) => {
      return tc(isMortgage.value ? 'years_count' : 'months_count', v, {
        count: v
      })
    }

    const classifiedId = computed(() => state.classifiedId)

    async function loadLoanInfo(ignorePopularity: boolean = false) {
      if (loadingLoanInfo.value || hasRangeError.value) {
        return
      }

      loadingLoanInfo.value = true
      try {
        const {
          monthlyInstallment,
          interest,
          maxInstallments: fetchedMaxInstallments,
          extras
        } = await loanService.getLoanInfo(
          LoanMerchantName.PIRAEUS,
          loanAmount.value,
          selectedTimeSlider.value,
          props.loanType,
          inClassifiedView.value ? classifiedId.value : undefined,
          undefined,
          ignorePopularity,
          isMortgage.value,
          isMortgage.value ? selectedInterestType.value : undefined,
          isMortgage.value && selectedInterestType.value === 'mixed'
            ? selectedFixedRateYears.value
            : undefined
        )
        loanInstallment.value = monthlyInstallment
        interestToUse.value = interest
        loanInfoExtras.value = extras || null
        if (!isMortgage.value && fetchedMaxInstallments) {
          maxInstallments.value = fetchedMaxInstallments
        } else if (extras?.installments) {
          // we are in mortgage mode
          const minToUse =
            selectedInterestType.value === 'mixed' &&
            extras.installments.min <= selectedFixedRateYears.value + 1
              ? selectedFixedRateYears.value + 1
              : extras.installments.min
          maxInstallments.value = extras.installments.max
          minInstallments.value = minToUse
        }
      } catch (error) {
        if (error.response?.data?.details?.max_installments) {
          maxInstallments.value = error.response?.data?.details.max_installments
        } else {
          handleRequestError(error)
        }
        loanInstallment.value = null
      } finally {
        loadingLoanInfo.value = false

        emit('update-loan-amount', loanAmount.value)
      }
    }

    const debounceLoadLoanInfo = debounce(() => {
      loadLoanInfo(false)
    }, DEBOUNCE_SWIFT)

    async function handleGetALoanButtonClick() {
      if (isMortgage.value) {
        isLoanFormVisible.value = true
        return
      }
      loadingLoanTarget.value = true
      try {
        const { targetUrl } = await loanService.getLoanTarget(
          LoanMerchantName.PIRAEUS,
          loanAmount.value,
          selectedTimeSlider.value,
          props.loanType,
          state.classifiedId
        )
        window.location.href = targetUrl
      } catch (e) {
        handleRequestError(e)
      } finally {
        loadingLoanTarget.value = false
      }
    }

    const formattedLoanInstallment = computed(() => {
      if (loanInstallment.value !== null) {
        return loanInstallment.value.toFixed(2)
      }
    })

    const amountInputWidth = computed(() => {
      const letterWidth = 14 // average
      if (loanAmount.value) {
        return `${formatNumber(loanAmount.value).toString().length *
          letterWidth}px`
      }
      return `${letterWidth}px`
    })

    const onAmountBlur = () => {
      showAmountInput.value = false
      // take the value from the input that was just blured
      const inputValue = Number(amountInputRef.value.value)

      if (inputValue <= minLoanAmount.value) {
        loanAmount.value = minLoanAmount.value
      } else if (inputValue >= maxLoanAmount.value) {
        loanAmount.value = maxLoanAmount.value
      } else {
        loanAmount.value = inputValue
      }

      loadLoanInfo(false)
    }

    const onAmountFocus = () => {
      if (!showAmountInput.value) {
        showAmountInput.value = true
      }
    }

    const onInstallmentsInput = (e: event) => {
      // take the value from the input that was just blured
      const inputValue = Number(e.target.value)
      if (
        inputValue >= minInstallments.value &&
        inputValue <= maxInstallments.value
      ) {
        selectedTimeSlider.value = inputValue
      }
      selectedTimeInput.value = inputValue

      loadLoanInfo(false)
    }
    const onInstallmentsBlur = () => {
      showInstallmentsInput.value = false
    }

    const onInstallmentsFocus = () => {
      if (!showInstallmentsInput.value) {
        showInstallmentsInput.value = true
      }
    }

    const onAmountClick = async () => {
      if (showAmountInput.value) {
        return
      }
      showAmountInput.value = true
      await nextTick()
      amountInputRef.value.focus()
      amountInputRef.value.setSelectionRange(-1, -1)
    }

    const onInstallmentsClick = async () => {
      if (showInstallmentsInput.value) {
        return
      }
      showInstallmentsInput.value = true
      await nextTick()
      installmentsInputRef.value.focus()
      installmentsInputRef.value.setSelectionRange(-1, -1)
    }

    const interestTypeOptions = computed(() => [
      {
        label: t('interest_rate_fixed'),
        value: 'fixed'
      },
      {
        label: t('interest_rate_variable'),
        value: 'variable'
      },
      {
        label: t('interest_rate_mixed'),
        value: 'mixed'
      }
    ])

    const fixedRateYearOptions = computed(() => {
      return PIRAEUS_MORTGAGE_FIXED_RATE_YEARS.map(y => {
        return {
          text: tc('years_count', y, {
            count: y
          }),
          value: y
        }
      })
    })

    const onFixedRateYearsChange = (years: number) => {
      if (
        years >= selectedTimeInput.value ||
        years >= loanInfoExtras.value.installments.min
      ) {
        const nextAvailable = PIRAEUS_MORTGAGE_FIXED_RATE_YEARS.find(
          y => y >= years
        )
        if (nextAvailable) {
          minInstallments.value = nextAvailable + 1
        } else {
          // fallback - if no larger value exists, set to max
          minInstallments.value =
            Math.max(...PIRAEUS_MORTGAGE_FIXED_RATE_YEARS) + 1
        }
      } else if (years < loanInfoExtras.value.installments.min) {
        minInstallments.value = loanInfoExtras.value.installments.min
      }
      debounceLoadLoanInfo()
    }

    const handleInstallmentsSliderChange = (val: number) => {
      selectedTimeInput.value = val
      debounceLoadLoanInfo()
    }

    const triggerInfoModal = () => {
      if (infoModalRef.value) {
        infoModalRef.value.triggerShow()
      }
    }

    const inDetailClick = () => {
      if (loanInfoExtras.value?.installments) {
        showDetailsModal.value = true
      }
    }

    return {
      selectedTimeSlider,
      selectedTimeInput,
      handleTimeButtonClick,
      sliderTooltipFormatter,
      durationSliderTooltipFormatter,
      loanAmount,
      classifiedRawPrice,
      maxLoanAmount,
      minLoanAmount,
      formatNumber,
      loanInstallment,
      loadingLoanTarget,
      handleGetALoanButtonClick,
      formattedLoanInstallment,
      amountInputWidth,
      showAmountInput,
      showInstallmentsInput,
      amountInputRef,
      installmentsInputRef,
      onAmountBlur,
      onAmountFocus,
      onInstallmentsBlur,
      onInstallmentsFocus,
      onAmountClick,
      minInstallments,
      maxInstallments,
      internalExpanded,
      t,
      interestToUse,
      PIRAEUS_CONSUMER_INTEREST,
      PIRAEUS_CONSUMER_CONTRIBUTION,
      PIRAEUS_CONSUMER_MAX_LOAN_AMOUNT,
      PIRAEUS_CONSUMER_MIN_LOAN_AMOUNT,
      PIRAEUS_MORTGAGE_CONTRIBUTION,
      loadLoanInfo,
      handleInstallmentsSliderChange,
      debounceLoadLoanInfo,
      onInstallmentsClick,
      showPiraeusTermsModal,
      hasRangeError,
      loadingLoanInfo,
      onInstallmentsInput,
      isMortgage,
      interestTypeOptions,
      selectedInterestType,
      fixedRateYearOptions,
      selectedFixedRateYears,
      onFixedRateYearsChange,
      infoModalRef,
      triggerInfoModal,
      loanInfoExtras,
      showDetailsModal,
      inClassifiedView,
      classifiedId,
      inDetailClick,
      isLoanFormVisible
    }
  },
  i18n: defineComponentTranslations({
    piraeus_bank_text: {
      en: 'You only need your Piraeus e‐Banking credentials',
      el: 'Χρειάζεσαι μόνο τους κωδικούς σου για το Piraeus e-banking'
    },
    piraeus_bank_mortgage_text: {
      en: 'Get it with a {bold}',
      el: 'Απόκτησέ το με {bold}'
    },
    piraeus_bank_mortgage_text_bold: {
      en: 'mortgage loan',
      el: 'στεγαστικό δάνειο'
    },
    piraeus_consumer_bottom_disclaimer: {
      en:
        'By clicking “Learn more” you will be automatically transferred to the Piraeus Bank website. In order to better serve you, Piraeus Bank will be notified that your login has been made through Car.gr.',
      el:
        'Με την επιλογή “Μάθε περισσότερα” θα μεταφερθείς αυτόματα στην ιστοσελίδα της Τράπεζας Πειραιώς. Με στόχο την καλύτερη εξυπηρέτησή σου θα γνωστοποιηθεί στην Τράπεζα Πειραιώς ότι η είσοδος σου έχει πραγματοποιηθεί μέσω του Car.gr'
    },
    piraeus_mortgage_bottom_disclaimer: {
      en:
        'By clicking "Apply Now", you will be taken to the expression of interest form for obtaining a mortgage loan from Piraeus Bank.',
      el:
        'Πατώντας «Κάνε Αίτηση Τώρα», θα μεταφερθείς στη φόρμα εκδήλωσης ενδιαφέροντος για την απόκτηση στεγαστικού δανείου από την Τράπεζα Πειραιώς.'
    },
    piraeus_bottom_terms: {
      en: 'Read the terms and conditions.',
      el: 'Δες τους όρους και τις προϋποθέσεις.'
    },
    installments_range_error_months: {
      en: 'Choose a term from {min} to {max} months',
      el: 'Επίλεξε διάρκεια από {min} έως {max} μήνες'
    },
    installments_range_error_years: {
      en: 'Choose a term from {min} to {max} years',
      el: 'Επίλεξε διάρκεια από {min} έως {max} έτη'
    },
    monthly_installment: {
      en: 'Monthly installment',
      el: 'Μηνιαία δόση'
    },
    monthly_installment_from: {
      en: 'Monthly installment from',
      el: 'Μηνιαία δόση από'
    },
    installment_shorter: {
      en: 'Installment',
      el: 'Μηνιαία δόση'
    },
    installment_shorter_from: {
      en: 'Installment from',
      el: 'Μηνιαία δόση από'
    },
    piraeus_installment_title: {
      en: 'Info on installment',
      el: 'Ενημέρωση για τη δόση'
    },
    piraeus_variable_interest_rate_info: {
      en:
        'Floating interest rate {rate}% plus contribution L.128/75 which currently amounts to {contribution}%',
      el:
        'Κυμαινόμενο επιτόκιο {rate}% πλέον εισφοράς Ν.128/75 που σήμερα ανέρχεται σε {contribution}%'
    },
    piraeus_fixed_interest_rate_info: {
      en:
        'Fixed interest rate {rate}% plus contribution which currently amounts to {contribution}%',
      el:
        'Σταθερό επιτόκιο {rate}% πλέον εισφοράς που σήμερα ανέρχεται σε {contribution}%'
    },
    interest_rate_fixed: {
      en: 'Fixed',
      el: 'Σταθερό'
    },
    interest_rate_variable: {
      en: 'Variable',
      el: 'Kυμαινόμενο'
    },
    interest_rate_mixed: {
      en: 'Mixed',
      el: 'Μεικτό'
    },
    interest_type: {
      en: 'Interest type',
      el: 'Είδος επιτοκίου'
    },
    mixed_interest_type_label: {
      en: 'Years of fixed interest',
      el: 'Έτη σταθερού επιτοκίου'
    }
  })
})
